<template>
  <div  style="width:100%;height:100%;">
    <div class="userratio">
      <div class="top">
        <div
          class="left"
          v-for="(item, index) in arr"
          :class="[{ dianji: arrkey == item }]"
          :key="index"
          @click="cutkey(item)"
        >{{ item }}</div>
      </div>
      <div v-show="arrkey == '物料占比'" class="topbtn" @click="btnshow"></div>
      <div v-show="arrkey == '物料占比'" class="bottom">
        <div class="tab-switch">
          <span
            v-for="item in tabData"
            :class="[{ current: tabKey == item }]"
            v-text="item"
            :key="item"
            @click="tabSwitch(item)"
          ></span>
        </div>
        <div v-show="arrkey == '物料占比'" class="tables common">
          <el-table
            :data="tableData"
            style="width:100%;font-size:12px;"
            height="255"
            border
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column align="center" prop="MaterialCode" label="编号"></el-table-column>
            <el-table-column
              align="center"
              prop="MaterialName"
              label="物料"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="Count"
              label="数量"
              :show-overflow-tooltip="true"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="bottomss" v-show="arrkey == '库龄分布'">
        <div id="echarts33" ref="chart" style="width:437px;height:315px;"></div>
      </div>
    </div>
    <el-dialog
      :title="arrkey"
      :visible.sync="centerDialog33"
      width="900px"
      center
    >
      <div class="tables">
        <el-table
          :data="tableData"
          style="width:100%;font-size:14px;"
          height="326"
          border
          :row-style="tableRowStylelog"
          :header-cell-style="tableHeaderColorlog"
        >
          <el-table-column align="center" prop="MaterialCode" label="编号"></el-table-column>
          <el-table-column align="center" prop="MaterialName" label="物料" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" prop="Count" label="数量" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "echarts33",
  data() {
    let arr = ["物料占比", "库龄分布"];
    let tabData = ["库区", "巷道", "货位"];
    return {
      arr: arr,
      arrkey: arr[0],
      tabData: tabData,
      tabKey: tabData[0],
      num: 5,
      pagesize: 6,
      pagenum: 1,
      centerDialog33: false,
      tableData:[],
      emptyTrayShowed: true,
    };
  },
  props:{
      echares33Data: {
      type: Array,
      default: () => {
        return [
          { value: 20, name: "0-7天" },
          { value: 30, name: "7-15天" },
          { value: 50, name: "15天以上" }
        ];
      }
    }
  },
  mounted() { 
    this.getWlzb();
    this.getKlfbList();  
  },
  watch: {

  },
  computed: {},
  methods: {
    getWlzb(){    //物料占比
      let self = this;
      let url = '/api/DataStatistical/Mat_Info';
      this.$handleRequest(window.ApiHost1+url, {
          "KeyWord": "",
          "ShelfNo": this.shelfNo,
          "WareHouseCode": window.PYKWareHouseCode,
        }, 'post', function(res) {  //success
          self.tableData = res.retData.Rows;
          console.log(res.retData.Rows);
        }, function(res) {  //fail
      });  
    },
     getKlfbList() {    //库龄分布
      let self = this;
      let url = '/api/DataStatistical/Inv_Age_Count';
      this.$handleRequest(window.ApiHost1+url, {
          "ShowEmptyTray": this.emptyTrayShowed,
          "WareHouseCode": window.PYKWareHouseCode,
        }, 'post', function(res) {  //success
          console.log(res)
          // self.echares33Data = res.retData.Rows;
          // self.pies();
        }, function(res) {  //fail
      });
    },
    //小按钮事件
    btnshow() {
      this.centerDialog33 = true;
    },
    pies() {
      var _this = this;
      // var behaviorpie = this.$echarts.init(
      //   document.getElementById("echarts32")
      // );
      let charts = this.$refs.chart;
      if (charts) {
        var behaviorpie = this.$echarts.init(charts);
        var colors = ["#375CF9", "#F52282", "#1EDECE", "#FEAD1C"];
        var option = {
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c} ({d}%)"
          },
          legend: {
            show: true,
            bottom: 0,
            textStyle: {
              color: "#f2f2f2",
              fontSize: 14
            },
            icon: "roundRect",
            data: _this.echares33Data
          },
          series: [
            {
              // name: "当日订单占比",
              type: "pie",
              radius: ["40%", "55%"],
              center: ["50%", "45%"],
              itemStyle: {
                // normal: {
                //   borderWidth: 5,
                //   borderColor: "#D8BFD8"
                // }
              },

              //  roseType: "area",   //设置不规则饼图
              color: [
                {
                  type: "radial",
                  x: 0.4,
                  y: 0.8,
                  r: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#375CF9" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(27, 40, 208, .8)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                },
                {
                  type: "radial",
                  x: 0.6,
                  y: 0.4,
                  r: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#F52282" // 0% 处的颜色
                    },
                    {
                      offset: 1,

                      color: "rgba(133, 40, 220, .8)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                },
                {
                  type: "radial",
                  x: 0.2,
                  y: 0.5,
                  r: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#1EDECE" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 232, 118, .8)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                },
                {
                  type: "radial",
                  x: 0.2,
                  y: 0.5,
                  r: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#FEAD1C" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(249, 54, 45, .8)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              ],
              label: {
                normal: {
                  position: "left",
                  formatter: "{d}% ",
                  color: "#fff",
                  fontSize: "16",
                  align: "right"
                }
              },
              data: _this.echares33Data
            }
          ]
        };
        behaviorpie.setOption(option);
      }
    },
    //大选项卡
    cutkey(item) {
      this.arrkey = item;
      this.$emit("echarts33key", item);
    },
    //小选项卡
    tabSwitch(item) {
      //   console.log(item);
      this.tabKey = item;
      //   this.getGzsjhzList();
      this.$emit("receive33data", item);
    },
    tableRowStyle() {
      return "background-color:#dcf4f8;color: #3d8875;height:26px;padding:0; ";
    },
    // 修改table header的背景色
    tableHeaderColor({ rowIndex }) {
      //   if (rowIndex === 0) {
      return "background-color: #dcf4f8;color: #3d8875;border-right:1px solid #fff;border-bottom:1px solid #fff;box-sizing:border-box;";
      //   }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      //   this.pagenum = val;
      //把当前页传递给父组件
      this.$emit("watchpage33", val);
    },
    tableRowStylelog() {
      return "background-color:#dcf4f8;color: #3d8875;height:26px;padding:0; ";
    },
    // 修改table header的背景色
    tableHeaderColorlog({ rowIndex }) {
      //   if (rowIndex === 0) {
       return "background-color: #dcf4f8;color: #3d8875;border-right:1px solid #fff;border-bottom:1px solid #fff;box-sizing:border-box;";
      //   }
    }
  }
};
</script>
<style scoped>
.userratio {
  width: 100%;
  height: 100%;
  position: relative;
}
.topbtn {
  width: 19px;
  height: 19px;
  background: url("../../assets/img/echarts34-02.png") no-repeat;
  position: absolute;
  right: 6px;
  top: 10px;
}
.tables >>> .el-table td,
.el-table th {
  padding: 0;
}
.tables >>> .el-input__inner {
  color: #fff;
  width: 30px;
  background: #2a5178 !important;
}
.tables >>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  border: none;
  width: 0;
  background: transparent;
}
.tables >>> .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #3d8875 !important;
  color: #DCF4F8 !important;
}
.tables >>> .el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: #fff;
  box-sizing: border-box;
}
.top {
  height: 38px;
  width: 100%;
  display: flex;
}
.left {
  width: 50%;
  height: 34px;
  background: #072132;
  line-height: 34px;
  color: #1edecf;
  text-align: center;
}
.dianji {
  background: #01665e;
  color: #fff;
}
.bottom {
  width: 100%;
}
.tab-switch {
  width: 240px;
  height: 30px;
  position: absolute;
  right: 40px;
  top: 56px;
}
.tab-switch span {
  color: #fff;
  font-size: 14px;
  text-align: center;
  width: 40px;
  padding: 3px;
  margin: 0px 10px;
  line-height: 24px;
  height: 24px;
  display: inline-block;
  background-color: #1b406d;
  border-radius: 3px;
}
.current {
  background: #07afa0 !important;
}
.common {
  margin-top: 60px;
  height: 255px;
  width: 100%;
}
.bottomfenye {
  width: 100%;
  height: 40px;
}
.bottomss {
  width: 100%;
  height: 315px;
}
</style>



// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts33.vue